import axios from 'axios'

export default () => {
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
//   axios.defaults.headers.post["Content-Type"] =
//     "application/json";
  // axios.defaults.headers.post['Content-Type'] ='application/json';
  // axios.defaults.withCredentials = true;
//   axios.defaults.headers.common = {
//     ...axios.defaults.headers.common,
//     'Access-Control-Allow-Origin': 'http://web.ahoorasystem.ir/api/',
//     "Content-Type": 'application/json'
//  };
axios.defaults.proxy = {
  host: 'http://web.ahoorasystem.ir/api'
};
 axios.defaults.preflightContinue = true;
//  axios.defaults.crossDomain = true;
  return axios.create({
    baseURL: 'http://web.ahoorasystem.ir/api/'
  })
}
